export const en = {
    "button-text-copy": "Copy",
    "color-black": "Black",
    "color-black-transparent": "White transparent",
    "color-white": "White",
    "color-white-transparent": "Black transparent",
    "error-no-available": "It will become available after the skill is published and it appears in the catalog",
    "header-badge-for-site": "Badge for the site",
    "header-direct-link": "Direct link",
    "label-badge": "Badge",
    "label-quick-launch": "To quickly launch a skill",
    "label-text-copy": "Code to insert",
    "label-theme": "Theme"
} as const;
export const ru = {
    "button-text-copy": "Скопировать",
    "color-black": "Черный",
    "color-black-transparent": "Белый прозрачный",
    "color-white": "Белый",
    "color-white-transparent": "Черный прозрачный",
    "error-no-available": "Станет доступно после публикации навыка и его появления в каталоге",
    "header-badge-for-site": "Бейдж для сайта",
    "header-direct-link": "Прямая ссылка",
    "label-badge": "Бейдж",
    "label-quick-launch": "Для быстрого запуска навыка",
    "label-text-copy": "Код для вставки",
    "label-theme": "Тема"
} as const;
